import React, { memo } from 'react';

import { Spinner } from '../../helpers/Spinner';
import { Avatar } from '../../Avatar';
import Button from '../../helpers/Button';

import { AddUser } from './AddUser';

import style from './style.module.css';

const ModuleSettingsTableComponent = ({
  directors,
  isLoading,
  roles,
  availableUsers,
  allUsers,
  pendingUsers,
  pendingDirectReports,
  onUserRemove,
  onUserAdd,
  onTeamRemove,
  onRoleChange,
  onPendingUserRoleChange,
}) => {
  const directorFullName = `${directors?.getIn(['director', 'firstName'], '')} ${directors?.getIn(
    ['director', 'lastName'],
    '',
  )}`;

  const getUserRoleName = id => {
    if (!id) {
      return '';
    }

    return allUsers?.find(user => user.get('id') === id)?.getIn(['roles', 0, 'name']);
  };

  return (
    <>
      <div className="panel panel-default">
        <div className="panel-heading">
          <h5 className={style.panelHeading}>Direct Reports</h5>
        </div>
        <div className="position-relative">
          {isLoading && <Spinner />}
          <div className="table-responsive">
            <table className="table table-blue mb0">
              <tbody>
                {directors && !isLoading && (
                  <tr>
                    <td className="w45">
                      <Avatar name={directorFullName} />
                    </td>
                    <td>
                      <span className="font-bold">{directorFullName}</span>
                      <div className="label label-muted text-uppercase font-size-10 ml10">
                        {getUserRoleName(directors?.getIn(['director', 'id']))}
                      </div>
                    </td>
                    <td className="w260">
                      <div className="d-flex align-items-center justify-content-end">
                        <div className="label label-info text-uppercase font-size-10">
                          {directors?.getIn(['director', 'title'], '')}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
                {directors?.get('directReports')?.map(report => {
                  const fullName = `${report.get('firstName')} ${report.get('lastName')}`;
                  const defaultValue =
                    roles?.find(role => role.get('title') === report.get('dashboardTitle'))?.get('id') || '';

                  return (
                    <tr key={report.get('id')}>
                      <td className="w45">
                        <Avatar name={fullName} />
                      </td>
                      <td>
                        <span className="font-bold">{fullName}</span>
                        <div className="label label-muted text-uppercase font-size-10 ml10">
                          {getUserRoleName(report?.get('id'))}
                        </div>
                      </td>
                      <td className="w260">
                        <div className="d-flex align-items-center justify-content-end">
                          <select
                            className="form-control input-lg mr10 w180"
                            defaultValue={defaultValue}
                            onChange={event => onRoleChange(event, report)}
                          >
                            {roles?.map(role => (
                              <option key={role.get('id')} value={role.get('id')}>
                                {role.get('title')}
                              </option>
                            ))}
                          </select>
                          <div className="label label-info text-uppercase font-size-10">{report.get('title')}</div>
                          <Button className="btn-link mr10" onClick={() => onUserRemove(report.get('membershipId'))}>
                            <i className="fa fa-close mr0" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {pendingDirectReports?.map(pendingReport => {
                  const fullName = `${pendingReport.get('firstName')} ${pendingReport.get('lastName')}`;

                  return (
                    <tr key={`pending-${pendingReport.get('userId')}`}>
                      <td className="w45">
                        <Avatar name={fullName} />
                      </td>
                      <td>
                        <span className="font-bold">{fullName}</span>
                        <div className="label label-muted text-uppercase font-size-10 ml10">
                          {getUserRoleName(pendingReport?.get('userId'))}
                        </div>
                      </td>
                      <td className="w260">
                        <div className="d-flex align-items-center justify-content-end">
                          <select
                            className="form-control input-lg mr10 w180"
                            defaultValue={pendingReport.get('directorDashboardUserTitleId')}
                            onChange={event => onPendingUserRoleChange(event, pendingReport.get('userId'))}
                          >
                            {roles?.map(role => (
                              <option key={role.get('id')} value={role.get('id')}>
                                {role.get('title')}
                              </option>
                            ))}
                          </select>
                          <Button className="btn-link mr10" onClick={() => onUserRemove(pendingReport.get('userId'))}>
                            <i className="fa fa-close mr0" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                <AddUser
                  onUserAdd={user => onUserAdd(user, null)}
                  sectionId={directors?.getIn(['director', 'id'])}
                  users={availableUsers}
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {directors?.get('teams')?.map(team => (
        <div key={team.get('id')} className="panel panel-default mt20">
          <div className="panel-heading d-flex align-items-center justify-content-space-between">
            <h5 className={style.panelHeading}>{team.get('name')}</h5>
            <Button className="btn-link btn-default" onClick={() => onTeamRemove(team.get('id'))}>
              <i className="fa fa-trash mr0 font-size-14 c-red" />
            </Button>
          </div>
          <div className="position-relative">
            {isLoading && <Spinner />}
            <div className="table-responsive">
              <table className="table table-blue mb0">
                <tbody>
                  {team.get('users').map(user => {
                    const fullName = `${user.get('firstName')} ${user.get('lastName')}`;
                    const defaultValue =
                      roles?.find(role => role.get('title') === user.get('dashboardTitle'))?.get('id') || '';

                    return (
                      <tr key={user.get('id')}>
                        <td className="w45">
                          <Avatar name={fullName} />
                        </td>
                        <td>
                          <span className="font-bold">{fullName}</span>
                          <div className="label label-muted text-uppercase font-size-10 ml10">
                            {getUserRoleName(user?.get('id'))}
                          </div>
                        </td>
                        <td className="w260">
                          <div className="d-flex align-items-center justify-content-end">
                            <select
                              className="form-control input-lg mr10 w180"
                              defaultValue={defaultValue}
                              onChange={event => onRoleChange(event, user)}
                            >
                              {roles?.map(role => (
                                <option key={role.get('id')} value={role.get('id')}>
                                  {role.get('title')}
                                </option>
                              ))}
                            </select>
                            <div className="label label-info text-uppercase font-size-10">{user.get('title')}</div>
                            {user.get('id') !== team.get('leadUserId') && (
                              <Button className="btn-link mr10" onClick={() => onUserRemove(user.get('membershipId'))}>
                                <i className="fa fa-close mr0" />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {pendingUsers
                    ?.filter(pendingUser => pendingUser.get('teamId') === team.get('id'))
                    .map(pendingUser => {
                      const fullName = `${pendingUser.get('firstName')} ${pendingUser.get('lastName')}`;

                      return (
                        <tr key={`pending-${pendingUser.get('userId')}`}>
                          <td className="w45">
                            <Avatar name={fullName} />
                          </td>
                          <td>
                            <span className="font-bold">{fullName}</span>
                            <div className="label label-muted text-uppercase font-size-10 ml10">
                              {getUserRoleName(pendingUser?.get('userId'))}
                            </div>
                          </td>
                          <td className="w260">
                            <div className="d-flex align-items-center justify-content-end">
                              <select
                                className="form-control input-lg mr10 w180"
                                defaultValue={pendingUser.get('directorDashboardUserTitleId')}
                                onChange={event => onPendingUserRoleChange(event, pendingUser.get('userId'))}
                              >
                                {roles?.map(role => (
                                  <option key={role.get('id')} value={role.get('id')}>
                                    {role.get('title')}
                                  </option>
                                ))}
                              </select>
                              <Button className="btn-link mr10" onClick={() => onUserRemove(pendingUser.get('userId'))}>
                                <i className="fa fa-close mr0" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  <AddUser
                    onUserAdd={user => onUserAdd(user, team.get('id'))}
                    sectionId={team.get('id')}
                    users={availableUsers}
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export const ModuleSettingsTable = memo(ModuleSettingsTableComponent);
